export default __webpack_public_path__ + "static/media/background-cp.a864f7de.jpg";